import { ImageId, imageIdFormat } from "@redotech/redo-ids-cockroach";

const IMAGE_DEV_USER = process.env.IMAGE_DEV_USER || "";

const IMAGE_CDN_URL = process.env.DATA_PUBLIC_URL;
const IMAGE_URL_PREFIX = IMAGE_DEV_USER ? `${IMAGE_DEV_USER}/` : "";

export function transformImageIdToCdnUrl(
  imageId: ImageId,
  imageName: string,
  ext: string,
): string {
  if (IMAGE_DEV_USER) {
    // Dev has no paid Cloudflare, so we can't rewrite the URL with regex.
    // Dev: https://data.getredo.dev/redo/optimized-images/{user}/img_xxx.jpg
    return `${IMAGE_CDN_URL}/redo/optimized-images/${IMAGE_URL_PREFIX}${imageId}.${ext}`;
  } else {
    // URL pattern: /optimized-images/{url_prefix?}{imageId}/{seoName}.{ext}
    // Prod: https://data.getredo.com/optimized-images/img_xxx/name.jpg
    return `${IMAGE_CDN_URL}/optimized-images/${IMAGE_URL_PREFIX}${imageId}/${imageName}.${ext}`;
  }
}

function sanitizeFilename(name: string): string {
  return (
    name
      .toLowerCase()
      .replace(/[^a-z0-9-]/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "") || "image"
  );
}

function getExtensionFromMimeType(mimeType: string): string {
  switch (mimeType) {
    case "image/png":
      return "png";
    case "image/jpeg":
      return "jpg";
    case "image/webp":
      return "webp";
    case "image/gif":
      return "gif";
    default:
      return "png";
  }
}

function getImageCdnUrl(image: {
  id: bigint | ImageId;
  name: string;
  mime_type?: string | null;
}): string {
  let imageId: ImageId;
  if (typeof image.id === "bigint") {
    imageId = imageIdFormat.write(image.id);
  } else {
    imageId = image.id;
  }
  const ext = getExtensionFromMimeType(image.mime_type || "image/jpeg");
  const safeName = sanitizeFilename(image.name);
  return transformImageIdToCdnUrl(imageId, safeName, ext);
}

export function deriveImageUrl(
  image: {
    id: ImageId | bigint;
    name: string;
    mime_type?: string | null;
    mimeType?: string | null;
  } | null,
  fallbackUrl: string | null,
): string {
  if (!image) {
    return fallbackUrl || "";
  }
  const mimeType = image.mime_type ?? image.mimeType ?? null;
  return getImageCdnUrl({
    id: image.id,
    name: image.name,
    mime_type: mimeType,
  });
}
